// extracted by mini-css-extract-plugin
module.exports = {"play":"Play_play__1uLKs","small":"Play_small__3tyh7"};